export const BASE_URL = 'https://api.themoviedb.org/3/';
export const API_KEY = '?api_key=c421e24b15869ea8f51f9e056f5494ee';
export const NORMAL_IMAGE_BASE_URL = 'https://image.tmdb.org/t/p/w300';
export const ORIGINAL_IMAGE_BASE_URL = 'https://image.tmdb.org/t/p/original';